<template>
  <div class="jumbotron">
    <div id="attribution-node"></div>
    <loading :active.sync="isLoading"></loading>
    <div class="row top-row">
      <div class="col-lg-4">
        <img id="profile-thumb" v-bind:src="profileImage" alt="Card image cap">
      </div>
      <div class="col-lg-8 my-auto">
        <h2>{{ getLegalFirstName }} {{ getLastName }}</h2>
        <h4>{{ getStreet1 }} {{ getStreet2 }}<br>{{ getCity }} {{ getState }} {{ getZipCode }}</h4>
      </div>
      <router-link to="/messaging">
        <i class="to-messaging fa fa-comments" aria-hidden="true"></i>
        <p class="unread-messages">{{ getNotificationNumber }}</p>
      </router-link>
    </div>
    <div class="row" v-if="savedHouses.length">
      <div class="col">
        <h4>My Saved Homes</h4>
        <data-card-carousel v-bind:searchResults="savedHouses" v-bind:cardType="'home-card'"></data-card-carousel>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4 v-if="getLegalFirstName">{{ getLegalFirstName }}'s Reviews</h4>
        <h4 v-else>Your Reviews</h4>
        <div v-for="review in reviews" :key="review.review_id">
          <hr class="divider">
          <div class="row">
            <div class="col-lg">
              <review :rating="review.rating"
                      :review="review.review"
                      :datePosted="review.date"
                      :reviewerId="review.reviewer_id"
                      :reviewId="review.review_id"
                      :reviewer="review.businessName"
                      :path="review.url"
                      v-on:reload="reload"
                      v-on:loading="setLoading"></review>
            </div>
          </div>
        </div>
        <button v-on:click="loadMoreReviews" class="btn btn-primary">Load More Reviews</button>
      </div>
    </div>
    <br/>
    <div class="row" v-if="claimedHouses.length">
      <div class="col">
        <h4 v-if="getLegalFirstName">{{ getLegalFirstName }}'s Claimed Houses</h4>
        <h4 v-else>Your Claimed Houses</h4>
        <div v-for="house in claimedHouses" v-bind:key="house.unique_id" v-on:click="viewProperty(house.unique_id)">
          <hr class="divider">
          <div class="row">
            <div class="col-4">
              <img v-if="house.photos" v-bind:src="signPhoto(house.photos)" alt="Home Cover Photo">
              <img v-else src="/static/NoPhotoAvailable.Yellow.svg" alt="Home Cover Photo">
              <house-tag v-bind:house="house"></house-tag>
            </div>
            <div class="col-8">
              <h5 class="address-part-one">{{ addressPartOne(house) }}</h5>
              <p class="address-part-two">{{ addressPartTwo(house) }}</p>
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <td><h5 v-if="house.bedroom_count" class="house-info">{{house.bedroom_count}} <i class="fas fa-bed"></i></h5></td>
                    <td><h5 v-if="house.bathroom_count" class="house-info">{{house.bathroom_count}} <i class="fas fa-bath"></i></h5></td>
                    <td><h5 v-if="house.house_sqft" class="house-info">{{house.house_sqft}} ft<sup>2</sup> <i class="fas fa-ruler-combined"></i></h5></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AWS from 'aws-sdk/global'
import AWSConnector from 'http-aws-es'
import elasticsearch from 'elasticsearch'
import router from '../../../../router/index.js'
import GooglePlaces from '../../../../lib/googlePlacesApi.js'
import Loading from 'vue-loading-overlay'
import S3 from 'aws-sdk/clients/s3'
import 'vue-loading-overlay/dist/vue-loading.css'
import DataCardCarousel from '../../../general/DataCardCarousel.vue'
import review from '../../../business/subnavItems/Review.vue'
import HouseTag from '../../../home/HouseTag.vue'

export default {
  created () {
    this.getClaimedHomes()
    this.getReviews()
    this.getSavedHomes()
  },
  components: {
    DataCardCarousel,
    HouseTag,
    Loading,
    review
  },
  data () {
    return {
      claimedHouses: [],
      savedHouses: [],
      reviews: [],
      isLoading: false,
      lastKey: null
    }
  },
  methods: {
    viewProperty (uniqueId) {
      router.push('/property/' + uniqueId)
    },
    addressPartOne (house) {
      let address1 = house.street_number + ' ' + house.street_name + ' ' + house.street_suffix
      if (house.unit_number) {
        address1 += ' Unit Number: #' + house.unit_number
      }
      return address1
    },
    addressPartTwo (house) {
      return house.city + ', ' + house.state + ' ' + house.zip_code
    },
    async getBusinessData (businessIds) {
      var attributionElement = document.getElementById('attribution-node')
      var client = this.$store.getters.getBusinessApigClientFactory
      var params = {}
      var pathTemplate = '/batchgetbusinesses'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        business_ids: [...new Set(businessIds)]
      }
      try {
        var homAptResults = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        var homAptBusinessIds = homAptResults.data.map((result) => result.business_id)
        var googleBusinessIds = businessIds.filter((id) => !homAptBusinessIds.includes(id))
        var googleResults = await Promise.all(googleBusinessIds.map((savedBusiness) => {
          if (!homAptBusinessIds.includes(savedBusiness)) return GooglePlaces.googleDetails(attributionElement, savedBusiness)
        }))
        for (var i = 0; i < googleResults.length; i++) {
          googleResults[i].businessId = googleBusinessIds[i]
        }
        var homAptCardData = homAptResults.data.reduce((cardData, businessData) => {
          cardData.push({
            businessId: businessData.business_id,
            title: businessData.display_name,
            isGoogle: 'false'
          })
          return cardData
        }, [])
        var googleCardData = googleResults.reduce((cardData, businessData) => {
          cardData.push({
            businessId: businessData.businessId,
            title: businessData.name,
            isGoogle: 'true'
          })
          return cardData
        }, [])
        return [...homAptCardData, ...googleCardData]
      } catch (error) {
        console.log(error)
      }
    },
    async getClaimedHomes () {
      this.isLoading = true
      AWS.config.update({
        credentials: new AWS.Credentials(this.getAccessKeyId, this.getSecretAccessKey, this.getSessionToken),
        region: window.CONFIG.Region
      })
      try {
        var client = this.$store.getters.getPropertyApigClientFactory
        var params = {} // {unique_id: 'MN:Stearns:82499540001'}
        var pathTemplate = '/properties' // '/properties/{unique_id}'
        var method = 'POST'
        var additionalParams = {}
        var body = {
          unique_ids: this.getClaimedHouses
        }
        let result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        result.data.forEach((house) => {
          if (house.photos) house.photos.sort()
        })
        this.claimedHouses = result.data
      } catch (error) {
        console.log(error)
      }
    },
    async getSavedHomes () {
      this.isLoading = true
      AWS.config.update({
        credentials: new AWS.Credentials(this.getAccessKeyId, this.getSecretAccessKey, this.getSessionToken),
        region: window.CONFIG.Region
      })
      try {
        var client = new elasticsearch.Client({
          connectionClass: AWSConnector,
          host: window.CONFIG.SearchDomain,
          apiVersion: '6.4'
        })
        const ids = []
        let houseCount = this.savedHousesCount
        for (var i = 0; i < houseCount; i++) {
          ids.push({_id: this.getSavedHouses[i]})
        }
        const results = await client.mget({
          index: 'house',
          type: '_doc',
          _source: ['house_sqft', 'bedroom_count', 'price', 'bathroom_count', 'state', 'street_name', 'street_number', 'street_suffix', 'city', 'photos', 'brokerage'],
          body: {docs: ids}
        })
        this.savedHouses = results.docs
        this.savedHouses.forEach((house) => {
          if (house._source.photos) house._source.photos.sort()
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getReviews () {
      this.isLoading = true
      var client = this.$store.getters.getReviewApigClientFactory
      var pathTemplate = '/reviews/'
      var method = 'GET'
      var params = {}
      var additionalParams = {
        queryParams: {
          cognito_id: this.getCognitoId
        }
      }
      var body = {}
      try {
        var reviews = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        var reviewData = reviews.data.data
        var businessNames = await this.getBusinessData(reviewData.map(function (business) {
          return business.business_id
        }))
        var fullReviews = reviewData.map(function (review) {
          var matchingBusiness = businessNames.find(function (element) {
            return review.business_id === element.businessId
          })
          review['businessName'] = matchingBusiness.title
          review['url'] = '/business/' + matchingBusiness.businessId + '/' + matchingBusiness.isGoogle + '/information'
          return review
        })
        this.reviews = fullReviews
        this.lastKey = reviews.data.last_evaluated_key
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async loadMoreReviews () {
      this.isLoading = true
      var client = this.$store.getters.getReviewApigClientFactory
      var params = {}
      var pathTemplate = '/reviews'
      var method = 'GET'
      var additionalParams = {
        queryParams: {
          cognito_id: this.getCognitoId,
          last_evaluated_key: JSON.stringify(this.lastKey)
        }
      }
      var body = {}
      try {
        if (this.lastKey === null) {
          this.isLoading = false
          return
        }
        var reviews = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        var businessNames = await this.getBusinessData(reviews.data.data.map(function (business) {
          return business.business_id
        }))
        var fullReviews = reviews.data.data.map(function (review) {
          var matchingBusiness = businessNames.find(function (element) {
            return review.business_id === element.businessId
          })
          review['businessName'] = matchingBusiness.title
          review['url'] = '/business/' + matchingBusiness.businessId + '/' + matchingBusiness.isGoogle + '/information'
          return review
        })
        for (var review in fullReviews) {
          this.reviews.push(fullReviews[review])
        }
        this.lastKey = reviews.data.last_evaluated_key
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    setLoading () {
      if (this.isLoading) this.isLoading = false
      if (!this.isLoading) this.isLoading = true
    },
    async reload () {
      await this.getClaimedHomes()
      await this.getReviews()
      await this.getSavedHomes()
      this.isLoading = false
    },
    signPhoto (photos) {
      if (!photos) return ''
      let s3 = new S3()
      let photoArray = photos[0].split('/')
      photoArray.shift()
      let photoKey = 'medium/' + photoArray.join('/')
      let params = {
        Bucket: window.CONFIG.MLSPhotoBucketName,
        Key: photoKey
      }
      return s3.getSignedUrl('getObject', params)
    }
  },
  computed: {
    ...mapGetters([
      'getAccessKeyId',
      'getCognitoId',
      'getSecretAccessKey',
      'getSessionToken'
    ]),
    ...mapGetters('user', [
      'getLegalFirstName',
      'getLastName',
      'getStreet1',
      'getStreet2',
      'getCity',
      'getState',
      'getZipCode',
      'getProfileImageUrl',
      'getNotificationNumber',
      'getClaimedHouses',
      'getSavedHouses',
      'getUserType'
    ]),
    profileImage () {
      if (this.$store.getters['user/getProfileImage']) {
        return this.getProfileImageUrl
      } else {
        return '/static/defaultprofile.png'
      }
    },
    claimedHousesCount () {
      return this.getClaimedHouses.length
    },
    savedHousesCount () {
      return this.getSavedHouses.length
    }
  },
  watch: {
    getUserType: function (newValue) {
      this.loading = true
      if (newValue === 'realtor') {
        router.replace('/profile/realtor/dashboard')
      } else if (newValue === 'lender') {
        router.replace('/profile/lender/dashboard')
      } else if (newValue === 'service provider') {
        router.replace('/profile/serviceprovider/dashboard')
      }
      this.loading = false
    }
  },
  mounted () {
    this.$global.gaEvent('userDashboard', 'navigation')
  }
}
</script>

<style scoped>
.address-part-one {
  font-size: 1.5rem;
  margin-bottom: 0;
}

.address-part-two {
  font-size: 1.5rem;
}

.to-messaging {
  position: absolute;
  right: 2rem;
  top: 1rem;
}

.unread-messages {
  position: absolute;
  right: 2.7rem;
  top: 1rem;
  font-size: 1.7rem;
}

.divider {
  margin-bottom: 0;
  margin-top: 0;
  height: 1px;
}

.top-row {
  padding-bottom: 1rem;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin {
  margin-top: 0px;
}

#profile-thumb {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover !important;
}

.col-lg >>> hr {
  visibility: hidden;
}

.business-name {
  padding-top: .3rem;
  margin-bottom: -1.3rem;
}

.fa-comments {
  font-size: 3rem;
  color: rgb(254, 237, 170);
}

.house-info {
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/userProfile/profiles/UserDashboard.vue